import React from "react";

const Input = ({placeholder}) => {
  return <input type="text" placeholder={placeholder}/>;
};

export default Input;
